var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"message":_vm.form.errors.get(_vm.fieldName),"type":{ 'is-danger': _vm.form.errors.has(_vm.fieldName) }}},[_c('b-input',{attrs:{"disabled":_vm.disabled,"type":"textarea"},model:{value:(_vm.form[_vm.fieldName]),callback:function ($$v) {_vm.$set(_vm.form, _vm.fieldName, $$v)},expression:"form[fieldName]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }